import { buildPastedImageName } from './buildPastedImageName'

const ensureFileName = (file: File, index: number, total: number): File => {
  if (file.name) return file

  const name = buildPastedImageName(file.type, index, total)

  return new File([file], name, { type: file.type, lastModified: file.lastModified })
}

export const getClipboardMediaFiles = (clipboardData: DataTransfer): File[] => {
  const fromItems = Array.from(clipboardData.items ?? [])
    .filter((item) => item.kind === 'file')
    .map((item) => item.getAsFile())
    .filter((file): file is File => Boolean(file))

  const files = fromItems.length ? fromItems : Array.from(clipboardData.files ?? [])

  return files.map((file, index) => ensureFileName(file, index, files.length))
}
